import Home from './Pages/Home';
import Header from './Pages/Header';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Project from './Pages/Project';
import Technologies from "./Pages/Technologies";

function App() {
  return (
    <>
    <Header />
    <Home />
    <About />
    <Technologies />
    <Project />
    <Contact />
    </>
  );
}

export default App;
